import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---------------------------------------------------------------------------
// Browser-translation crash protection (Safari Translate / Google Translate).
//
// Machine translators replace React-managed text nodes with their own <font>
// wrappers. On the next re-render React calls removeChild/insertBefore on a
// node that is no longer where it expects, and WebKit throws:
//   NotFoundError: "The object can not be found here."
// which crashed the booking flow for translated clients.
//
// Standard mitigation (facebook/react#11538): make those two DOM calls
// tolerant of nodes that were moved by the translator.
// ---------------------------------------------------------------------------
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      // eslint-disable-next-line no-console
      console.warn(
        "[translation-guard] suppressed removeChild on a node moved by a browser translator"
      );
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      // eslint-disable-next-line no-console
      console.warn(
        "[translation-guard] suppressed insertBefore against a node moved by a browser translator"
      );
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
